/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items available`)
};

const es_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay elementos disponibles`)
};

const de_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Einträge verfügbar`)
};

const nl_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen items beschikbaar`)
};

const fr_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun élément disponible`)
};

const it_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun elemento disponibile`)
};

const pt_br2_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item disponível`)
};

const pt_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum item disponível`)
};

const ja_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能なアイテムがありません`)
};

const zh_f1_modal_no_items = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无可用项目`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_modal_no_items = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_modal_no_items(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_modal_no_items", locale)
	if (locale === "en") return en_f1_modal_no_items(inputs)
	if (locale === "es") return es_f1_modal_no_items(inputs)
	if (locale === "de") return de_f1_modal_no_items(inputs)
	if (locale === "nl") return nl_f1_modal_no_items(inputs)
	if (locale === "fr") return fr_f1_modal_no_items(inputs)
	if (locale === "it") return it_f1_modal_no_items(inputs)
	if (locale === "pt-BR") return pt_br2_f1_modal_no_items(inputs)
	if (locale === "pt") return pt_f1_modal_no_items(inputs)
	if (locale === "ja") return ja_f1_modal_no_items(inputs)
	return zh_f1_modal_no_items(inputs)
};